<template>
  <v-container class="dark-overlay" :class="{small}">
    <v-row justify="center" class="fill-height" align="center">
      <v-col>
        <v-row>
          <v-progress-circular :indeterminate="true"></v-progress-circular><span style="margin-left:10px; margin-right:10px">{{$t('components.video_record.reconnecting_title')}}</span>
        </v-row>
        <v-row>
          <span class="subtitle-2">{{$t('components.video_record.reconnecting_description')}}</span>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "Reconnecting",
    props:{
      small : {
        type:Boolean,
        default:false
      }
    }
  }
</script>

<style scoped>
  .dark-overlay{
    font-family: Roboto, sans-serif;
    font-size: 18pt;
    background-color: black;
    opacity: 0.7;
    width:100%;
    height:100%;
    font-weight: bold;
  }

  .dark-overlay.small{
    font-size: 12pt;
  }

  .dark-overlay.small .subtitle-2{
    font-size: 12px!important;
  }
</style>